import {AfterViewInit, Component, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {GridsterComponent, GridsterConfig, GridsterItemComponent} from 'angular-gridster2';
import {DashboardWidget} from '../../../../shared/store/report/report-dashboard';

@Component({
  selector:    'app-grid',
  templateUrl: './grid.component.html',
  styleUrls:   ['./grid.component.scss'],
})
export class GridComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(GridsterComponent) public readonly gridsterC: GridsterComponent;
  @ViewChildren(GridsterItemComponent) public readonly gridsterItems: QueryList<GridsterItemComponent>;

  @Input() public readonly: boolean = false;

  public dashboard: Array<DashboardWidget> = [];
  @Input('dashboard') set _dashboard(dashboard: DashboardWidget[]) {
    this.dashboard = dashboard;

    if (this.gridsterItems) {
      const gridsterItems: GridsterItemComponent[] = this.gridsterItems.toArray();

      for (let i = 0;i < gridsterItems.length; i++) {
        if (!dashboard[i]) continue;

        gridsterItems[i].item.cols = dashboard[i].cols;
        gridsterItems[i].item.rows = dashboard[i].rows;
        gridsterItems[i].item.x = dashboard[i].x;
        gridsterItems[i].item.y = dashboard[i].y;

        gridsterItems[i].updateItemSize();
        gridsterItems[i].updateOptions();
      }

      if (this.gridsterC) {
        this.gridsterC.updateGrid();
        this.gridsterC.onResize()
      }
    }
  }

  public options: GridsterConfig;

  constructor() {}

  public ngOnInit() {
    this.options = {
      gridType: 'verticalFixed',
      margin: 20,
      maxCols: 6,
      minCols: 6,
      minRows: 6,
      maxRows: 1000,
      fixedRowHeight: 60,
      draggable: {
        enabled: false
      },
      resizable: {
        enabled: false
      },
      swap: false,
      pushItems: true
    };
  }

  public ngAfterViewInit(): void {}

  public ngOnDestroy(): void {}

  public updateSize(): void {
    this.gridsterC?.onResize();
  }

}
